import { useCallback, useEffect, useMemo, useState } from "react";
import { useSelector, useDispatch } from "react-redux"
import debounce from 'lodash.debounce';
import { CloseButton, Box, InputGroup, InputLeftElement, Input, InputRightElement } from "@chakra-ui/react";
import { FiSearch } from "react-icons/fi";
import ButtonPrimary from "components/button/ButtonPrimary";
import { IoAddCircle } from "react-icons/io5";
import { SET_TO_DEFAULT_RESPONSE, create } from "../../../store/features/slices/compraSlice";
import { get as getProveedores } from "../../../store/features/slices/proveedorSlice";
import { UPDATE_STOCK_PRODUCT_B, getByPage as getByPagePro } from "../../../store/features/slices/productoSlice";
import { addToCartB, getMyCartB, removeFromCartB, resetMutationResult, resetUserCartB } from "../../../store/features/slices/cartSlice";
import { uriSerialized } from "utils/uriSerialized";
import AutoComplete from "components/autocomplete/AutoComplete";
import { message } from "utils/Funciones";
import TableCartItemsPob from "./table/TableCartItemsPob";
import TablePaginationPob from "./table/TablePaginationPob";

const Reabastecer = () => {
    const dispatch = useDispatch();
    const { userToken, user } = useSelector((state) => state.userReducer);
    const {
        responseSuccessCreate,
        isLoading,
    } = useSelector((state) => state.compraReducer);

    const {
        dataByPage: dataByPagePro,
        totalPage: totalPagePro,
        totalRow: totalRowPro,
        isLoading: isLoadingPro
    } = useSelector((state) => state.productoReducer);

    const {
        data: proveedores
    } = useSelector((state) => state.proveedorReducer);

    const {
        isMutation, userCartB, numOfCartItemsB
    } = useSelector((state) => state.cartReducer);

    const [searchTermProductos, setSearchTermProductos] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [state, setState] = useState({
        proveedor: "",
        metodopago: ""
    })

    const setDefaultState = () => {
        setState({
            ...state,
            proveedor: "",
            metodopago: ""
        })
    }

    useEffect(() => {
        dispatch(getProveedores(userToken));
    }, [dispatch])

    useEffect(() => {
        const queryOptions = {
            userId: userToken && user.id
        }
        const query = queryOptions ? "?" + uriSerialized(queryOptions) : ""
        if (isMutation.success) {
            dispatch(resetMutationResult());
            dispatch(getMyCartB({ query: query, token: userToken }))
        } else {
            dispatch(getMyCartB({ query: query, token: userToken }))
        }
    }, [dispatch, isMutation.success])

    const onRemoveFromCart = (itemId) => {
        dispatch(removeFromCartB({ itemId: itemId, userId: userToken && user.id }))
    }

    const handleAgregarAlCarrito = (product) => {
        const formData = {
            userId: userToken && user.id,
            productId: product.product._id,
            quantity: product.quantity,
            price_unit: product.price_unit
        }
        dispatch(addToCartB({ formData: formData, token: userToken }))
    }

    const onSaveItemUpdate = (productId, price_unit, quantity) => {
        const formData = {
            userId: userToken && user.id,
            productId: productId,
            quantity: quantity,
            price_unit: price_unit
        }
        dispatch(addToCartB({ formData: formData, token: userToken }))
    }

    const onSubmitRegistrar = async (e) => {
        e.preventDefault();

        if (!state.proveedor) {
            message("Debes seleccionar un proveedor.", "error", 3);
            return;
        }

        if (!state.metodopago) {
            message("Debes seleccionar un método de pago.", "error", 3);
            return;
        }

        const formData = new FormData();
        state.userId = userToken && user.id;
        formData.append('data', JSON.stringify(state));

        await dispatch(create({ formData }));
    };

    useEffect(() => {
        if (responseSuccessCreate) {
            message(responseSuccessCreate.message, 'success', 5)
            dispatch(UPDATE_STOCK_PRODUCT_B(responseSuccessCreate.cart))
            dispatch(resetUserCartB(responseSuccessCreate.cartClear))
            setDefaultState()
            //registrar.onClose()
            dispatch(SET_TO_DEFAULT_RESPONSE())
        }
    }, [responseSuccessCreate])

    const fetchDataPro = useCallback(
        (pageSize, pageIndex, search) => {
            const queryOptions = {
                page: Number(pageIndex) - 1,
                limit: Number(pageSize),
                search: search,
                order: ""
            }
            const query = queryOptions ? "?" + uriSerialized(queryOptions) : ""
            dispatch(getByPagePro({ query: query, token: userToken }))
        },
        []
    )

    useEffect(() => {
        fetchDataPro(pageSize, currentPage, searchTermProductos)
    }, [currentPage, pageSize, searchTermProductos])

    const onChangeSearchTermProductos = e => {
        setSearchTermProductos(e.target.value);
    };
    const onChangeSearchTermClearProductos = e => {
        setSearchTermProductos("");
        document.getElementById("searchProductos").value = "";
    };

    const debounceSearchTermProductos = useMemo(() => debounce(onChangeSearchTermProductos, 700), []);

    return (
        <div className="mt-4 md:mt-0">
            <div className="mt-3 md:mt-8">
                <div className="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-65-35 gap-2 !z-[1004]">
                    <div className="overflow-y-scroll h-[calc(100vh-85px)] w-full">
                        <div className="min-h-[78vh] mt-4 md:mt-0">
                            <div className="sticky z-30 w-full flex items-center justify-end bg-white dark:!bg-navy-800 p-2 rounded-xl shadow-xl shadow-gray-200 dark:shadow-none">
                                <div className="relative flex h-[61px] w-[calc(100%-55px)] flex-grow items-center gap-2 rounded-full bg-white px-0 py-2 dark:!bg-navy-800">
                                    <InputGroup className="!w-full md:!w-[325px]">
                                        <InputLeftElement pointerEvents="none" className="!mt-1 !ml-1">
                                            <FiSearch size={24} className="text-navy-500 dark:text-navy-300" />
                                        </InputLeftElement>
                                        <Input size='lg' id="searchProductos" onChange={debounceSearchTermProductos} type="text" placeholder={`Buscar productos...`} className="flex w-full !rounded !border-[2.5px] !transition-all !duration-200 !ease-in-out !bg-lightPrimary dark:!bg-navy-900
                !text-gray-800 dark:!text-white
                !border-gray-300 dark:!border-white/10
                   focus:!border-brand-500 focus:!ring-[1px] focus:!ring-brand-500
                   dark:focus:!border-brand-400 dark:focus:!ring-brand-400
                   hover:!border-brand-500 dark:hover:!border-brand-400
                   placeholder:!text-gray-400 dark:placeholder:!text-gray-500
                   focus:!shadow-sm" />
                                        <InputRightElement className="!mt-1">
                                            <CloseButton onClick={onChangeSearchTermClearProductos} size='md' className={`mr-2 ${searchTermProductos.trim().length > 0 ? 'scale-100' : 'scale-0'} transition-all duration-500 text-navy-500 dark:text-navy-300`} />
                                        </InputRightElement>
                                    </InputGroup>
                                </div>
                            </div>
                            <div className="mt-5 grid grid-cols-1">
                                <Box>
                                    <TablePaginationPob
                                        loading={isLoadingPro}
                                        data={dataByPagePro}
                                        currentPage={currentPage}
                                        totalPages={totalPagePro}
                                        onPageChange={setCurrentPage}
                                        pageSize={pageSize}
                                        onPageSizeChange={setPageSize}
                                        handleAgregarAlCarrito={handleAgregarAlCarrito}
                                    />
                                </Box>
                            </div>
                        </div>
                    </div>
                    <div className="overflow-y-scroll h-[calc(100vh-85px)] w-full">
                        <form className="w-full" onSubmit={onSubmitRegistrar}>
                            <div className="flex flex-wrap">
                                <AutoComplete
                                    autoFocus={true}
                                    extra="w-full md:w-6/12 mb-3 p-2"
                                    label="Proveedor"
                                    data={proveedores}
                                    value={state.proveedor}
                                    required={true}
                                    labelProp="razon"
                                    valueProp="_id"
                                    onChange={(val) => setState({ ...state, proveedor: val })}
                                />

                                <div className="w-full grid grid-cols-1 mt-3">
                                    <TableCartItemsPob
                                        userCart={userCartB}
                                        loading={isMutation.loading}
                                        onRemoveFromCart={onRemoveFromCart}
                                        metodopagoval={state.metodopago}
                                        onSaveItemUpdate={onSaveItemUpdate}
                                        onUpdateMetodoPago={(val) => setState({ ...state, metodopago: val })}
                                    />
                                </div>

                                <div className="sticky bottom-0 w-full">
                                    <ButtonPrimary loadingText={`Guardando datos`} isLoading={isLoading} disabled={userCartB.cart?.cartItems?.length > 0 ? false : true} icon={<IoAddCircle size={28} />}>
                                        Registrar
                                    </ButtonPrimary>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div >

    );
};

export default Reabastecer;
